import React, { Component } from "react";

import { getCookieData, getUserId } from "../../../../utils/CommonFunction";
import { petrolRequest } from "../../../../utils/apiRoutes";
import { getHeaders } from "../../../../utils/apiHelper";

import PetrolRequestFilters from "./PetrolRequestFilters";
import PetrolRequestsTable from "./PetrolRequestsTable";

export default class PetrolRequests extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user_info: getCookieData("user_info"),
      userId: getUserId("user_info"),
      tab: "all-request",
      petrolRequests: [],
      filterStatus: null,
    };
  }

  switchTab(tab) {
    this.setState({ tab, filterStatus: null });
  }

  async handleClickSearch(filters) {
    try {
      const res = await fetch(this.petrolRequestsGetRoute(filters), {
        headers: getHeaders(),
      });
      const responseData = await res.json();

      if (!res.ok) {
        if (responseData.status === "error" && !!responseData.message) {
          return this.showError(responseData.message);
        }
        return this.showError("Couldn't load petrol requests!");
      }

      this.setState({
        petrolRequests: responseData.data,
        filterStatus: null,
      });
    } catch (error) {
      this.showError("Couldn't load petrol requests!");
    }
  }

  filterByStatus(status) {
    this.setState({
      filterStatus: status,
    });
  }

  petrolRequestsGetRoute(filters) {
    const fromDate = filters.from_date;
    const toDate = filters.to_date;

    const formNoFilter = filters.form_no ? `/${filters.form_no}` : "";
    const plateNumberFilter = filters.plate_number
      ? `/${filters.plate_number}`
      : "";
    const employeeIdFilter = filters.employee_id
      ? `/${filters.employee_id}`
      : "";
    const regionFilter = filters.region ? `/${filters.region}` : "";
    const branchFilter = filters.branch ? `/${filters.branch}` : "";
    const departmentFilter = filters.department ? `/${filters.department}` : "";
    const positionFilter = filters.position ? `/${filters.position}` : "";
    const vehicleTypeFilter = filters.vehicle_type
      ? `/${filters.vehicle_type}`
      : "";

    return `${petrolRequest}/start-date/${fromDate}/end-date/${toDate}/form-no${formNoFilter}/plate-number${plateNumberFilter}/employee-id${employeeIdFilter}/region${regionFilter}/branch${branchFilter}/department${departmentFilter}/position${positionFilter}/vehicle-type${vehicleTypeFilter}`;
  }

  showError = (message) => {
    this.props.showError(message);
  };

  render() {
    const isMyRequestTab = this.state.tab !== "all-request";
    const petrolRequests = this.state.petrolRequests.filter((petrol) => {
      let statusPass = true;
      if (this.state.filterStatus !== null) {
        statusPass = this.state.filterStatus === petrol.status;
      }
      return isMyRequestTab
        ? petrol.createdBy === this.state.userId && statusPass
        : petrol.createdBy !== this.state.userId && statusPass;
    });

    return (
      <div>
        <div className="row border-bottom white-bg dashboard-header">
          <div className="row">
            <div>
              <ul className="nav nav-tabs tab" role="tablist" id="tab-pane">
                <li className="nav-item">
                  <a
                    className="nav-link"
                    href="#approve_list"
                    role="tab"
                    data-toggle="tab"
                    aria-selected="true"
                    onClick={() => this.switchTab("my-request")}
                  >
                    My Request
                  </a>
                </li>
                <li className="nav-item1 active">
                  <a
                    className="nav-link active"
                    href="#approve_list"
                    role="tab"
                    data-toggle="tab"
                    onClick={() => this.switchTab("all-request")}
                  >
                    All Request
                  </a>
                </li>
              </ul>
              <PetrolRequestFilters
                onClickSearch={this.handleClickSearch.bind(this)}
                isAllTab={this.state.tab === "all-request"}
                petrolVehicleTypes={this.props.petrolVehicleTypes}
                withdrawalLocations={this.props.withdrawalLocations}
                employees={this.props.employees}
                regions={this.props.regions}
                departments={this.props.departments}
                positions={this.props.positions}
              />
              <PetrolRequestsTable
                petrolRequests={petrolRequests}
                onViewDetail={this.props.onViewDetail}
                onEditDetail={this.props.onEditDetail}
                permission={this.props.permission}
                filterByStatus={this.filterByStatus.bind(this)}
                showError={this.showError}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
